var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-text',{staticClass:"my-10 px-4 text--bold"},[_vm._v("\n                    "+_vm._s(_vm.$t("pagina-404.texto.no-existe"))+"\n                ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }